import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addProduct,
    deleteProduct,
    getProduct,
    hsnDropdown,
    searchProduct,
    updateProduct,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function ProductMaster() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [ids, setIds] = useState(null);
    const [mainPage, setMainPage] = useState('1');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const [initialValues, setInitialValues] = useState({
        productName: '',
        makeCompanyName: '',
        perPack: '',
    });

    const validationSchema = Yup.object().shape({
        productName: Yup.string().required('Product Name is required'),
        makeCompanyName: Yup.string().required('Company Name is required'),
        perPack: Yup.string().required('Per Pack is required'),
    });
    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const productData = useSelector((state) => state.master);

    const [formData, setFormData] = useState({
        productName: '',
        makeCompanyName: '',
        mfgBy: '',
        perPack: '',
        salePack: '',
        mrp: '',
        hsnCode: '',
    });

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const [selectedHSN, setSelectedHSN] = useState({
        hsnCode: '',
        gst: '',
        igst: '',
        cgst: '',
        sgst: ''
    });

    const handleHSNSelect = (hsn) => {
        setSelectedHSN({
            hsnCode: hsn.hsnCode,
            gst: hsn.gst,
            igst: hsn.igst,
            cgst: hsn.cgst,
            sgst: hsn.sgst
        });
    };

    const handleAddProduct = (values, { resetForm }) => {
        const payload = {
            productName: values.productName,
            makeCompanyName: values.makeCompanyName,
            mfgBy: values.mfgBy,
            perPack: values.perPack,
            salePack: values.salePack,
            mrp: values.mrp,
            hsnCode: selectedHSN.hsnCode,
        };
        dispatch(addProduct(payload, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteProduct = (values) => {
        const payload = {
            productName: values.productName,
            makeCompanyName: values.makeCompanyName,
            mfgBy: values.mfgBy,
            perPack: values.perPack,
            salePack: values.salePack,
            mrp: values.mrp,
            hsnCode: values.hsnCode,
        };

        dispatch(updateProduct(payload, limits, ids)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteProduct = () => {
        dispatch(deleteProduct(ids, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
        };
        setSearchDefault(newSearchParams);
        const queryParams = new URLSearchParams(newSearchParams).toString();
        dispatch(searchProduct(queryParams, newSearchParams.page));
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
        };
        setSearchDefault(updatedSearchParams);
        const queryParams = new URLSearchParams(updatedSearchParams).toString();
        dispatch(searchProduct(queryParams, updatedSearchParams.page));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        productData?.getProduct?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        if (searchQuery) {
            const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
            const queryParams = new URLSearchParams(updatedSearchParams).toString();
            dispatch(searchProduct(queryParams, updatedSearchParams.page));
        } else {
            dispatch(getProduct(limits));
        }
        dispatch(hsnDropdown())
    }, [mainPage, rowsPerPage]);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Product
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">Product Master</h3>
                    <div className='ms-auto border-r me-3 pe-3'>Total Records: <span className='text-success underline underline-offset-2 ps-2'>{productData?.getProduct?.data?.totalCount || 0}</span></div>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Product Code</Th>
                                <Th>Product Name</Th>
                                <Th>Make Company Name</Th>
                                <Th>MFG By</Th>
                                <Th>Per Pack</Th>
                                <Th>Sale Pack</Th>
                                <Th>MRP</Th>
                                <Th>HSN Code</Th>
                                <Th>GST</Th>
                                <Th>LGST</Th>
                                <Th>SGST</Th>
                                <Th>CGST</Th>
                                <Th className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {productData?.getProduct?.data?.data?.length > 0 ? (
                                productData?.getProduct?.data?.data?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.productCode}</Td>
                                            <Td className='uppercase'>{res.productName}</Td>
                                            <Td>{res.makeCompanyName}</Td>
                                            <Td className='uppercase'>{res.mfgBy}</Td>
                                            <Td className='uppercase'>{res.perPack}</Td>
                                            <Td className='uppercase'>{res.salePack}</Td>
                                            <Td>{res.mrp}</Td>
                                            <Td>{res.hsnCode}</Td>
                                            <Td>{res.gst}</Td>
                                            <Td>{res.igst}</Td>
                                            <Td>{res.sgst}</Td>
                                            <Td>{res.cgst}</Td>
                                            <Td style={{ minWidth: '200px' }}>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={13} textAlign="center">
                                            Product Not Found
                                        </Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add product */}

            <Modal show={show} onHide={toggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Product</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAddProduct}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Product Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="productName"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('productName', e.target.value)
                                                }
                                                value={values.productName}
                                                placeholder="Enter Product Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="productName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Make Company Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="makeCompanyName"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('makeCompanyName', e.target.value)
                                                }
                                                value={values.makeCompanyName}
                                                placeholder="Enter Make Company Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="makeCompanyName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>MFG By</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="mfgBy"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('mfgBy', e.target.value)
                                                }
                                                value={values.mfgBy}
                                                placeholder="Enter MFG By"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="mfgBy"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Per Pack</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="perPack"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('perPack', e.target.value)
                                                }
                                                value={values.perPack}
                                                placeholder="Enter Per Pack"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="perPack"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Sale Pack</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="salePack"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('salePack', e.target.value)
                                                }
                                                value={values.salePack}
                                                placeholder="Enter Sale Pack"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="salePack"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>MRP</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="mrp"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('mrp', e.target.value)
                                                }
                                                value={values.mrp}
                                                placeholder="Enter MRP"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="mrp"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>HSN Code</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {selectedHSN.hsnCode || 'Select HSN Code'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {
                                                        productData?.hsnDropdown?.data?.hsnData?.length > 0 ? (
                                                            productData?.hsnDropdown?.data?.hsnData?.map((res) => {
                                                                return (
                                                                    <Dropdown.Item key={res._id} onClick={() => handleHSNSelect(res)}>{res.hsnCode}</Dropdown.Item>
                                                                )
                                                            })
                                                        ) : (
                                                            <Dropdown.Item>No any data</Dropdown.Item>
                                                        )
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="diagnosis"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('diagnosis', e.target.value)
                                                }
                                                value={selectedHSN.gst}
                                                placeholder="Enter GST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="diagnosis"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>IGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="diagnosis"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('diagnosis', e.target.value)
                                                }
                                                value={selectedHSN.igst}
                                                placeholder="Enter IGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="diagnosis"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>CGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="diagnosis"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('diagnosis', e.target.value)
                                                }
                                                value={selectedHSN.cgst}
                                                placeholder="Enter CGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="diagnosis"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>SGST</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="diagnosis"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('diagnosis', e.target.value)
                                                }
                                                value={selectedHSN.sgst}
                                                placeholder="Enter SGST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="diagnosis"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update product */}

            <Modal show={updateModal} onHide={updateToggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Product</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteProduct}
                >
                    {({ handleSubmit, setFieldValue, values }) => {
                        const handleHSNSelect = (hsn) => {
                            setFieldValue('hsnCode', hsn.hsnCode);
                            setFieldValue('gst', hsn.gst);
                            setFieldValue('igst', hsn.igst);
                            setFieldValue('cgst', hsn.cgst);
                            setFieldValue('sgst', hsn.sgst);
                        };
                        return (
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body>
                                    <div className="row">
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Product Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="productName"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('productName', e.target.value)
                                                    }
                                                    value={values.productName}
                                                    placeholder="Enter Product Name"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="productName"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Make Company Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="makeCompanyName"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('makeCompanyName', e.target.value)
                                                    }
                                                    value={values.makeCompanyName}
                                                    placeholder="Enter Make Company Name"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="makeCompanyName"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>MFG By</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="mfgBy"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('mfgBy', e.target.value)
                                                    }
                                                    value={values.mfgBy}
                                                    placeholder="Enter MFG By"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="mfgBy"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Per Pack</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="perPack"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('perPack', e.target.value)
                                                    }
                                                    value={values.perPack}
                                                    placeholder="Enter Per Pack"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="perPack"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Sale Pack</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="salePack"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('salePack', e.target.value)
                                                    }
                                                    value={values.salePack}
                                                    placeholder="Enter Sale Pack"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="salePack"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>MRP</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="mrp"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('mrp', e.target.value)
                                                    }
                                                    value={values.mrp}
                                                    placeholder="Enter MRP"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="mrp"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>HSN Code</Form.Label>
                                                <Dropdown>
                                                    <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                        {values.hsnCode || 'Enter HSN Code'}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className='w-full'>
                                                        {
                                                            productData?.hsnDropdown?.data?.hsnData?.length > 0 ? (
                                                                productData?.hsnDropdown?.data?.hsnData?.map((res) => {
                                                                    return (
                                                                        <Dropdown.Item key={res._id} onClick={() => handleHSNSelect(res)}>{res.hsnCode}</Dropdown.Item>
                                                                    )
                                                                })
                                                            ) : (
                                                                <Dropdown.Item>No any data</Dropdown.Item>
                                                            )
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>GST</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="diagnosis"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('diagnosis', e.target.value)
                                                    }
                                                    value={values.gst}
                                                    placeholder="Enter GST"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="diagnosis"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>IGST</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="diagnosis"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('diagnosis', e.target.value)
                                                    }
                                                    value={values.igst}
                                                    placeholder="Enter IGST"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="diagnosis"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>CGST</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="diagnosis"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('diagnosis', e.target.value)
                                                    }
                                                    value={values.cgst}
                                                    placeholder="Enter CGST"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="diagnosis"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>SGST</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="diagnosis"
                                                    as={Form.Control}
                                                    onChange={(e) =>
                                                        setFieldValue('diagnosis', e.target.value)
                                                    }
                                                    value={values.sgst}
                                                    placeholder="Enter SGST"
                                                    className="shadow-none focus:!border-theme-dark"
                                                />
                                                <ErrorMessage
                                                    name="diagnosis"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={updateToggle}
                                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                    >
                                        Close
                                    </Button>
                                    <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                        Update
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        )
                    }}
                </Formik>
            </Modal>

            {/* delete product */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteProduct}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
